<template>
	<v-group :config="{ rotation }">
		<v-wedge
			:config="{
				x: 0,
				y: 0,
				radius,
				angle,
				fillRadialGradientStartPoint: {x: 0, y: 0},
				fillRadialGradientStartRadius: 0,
				fillRadialGradientEndPoint: {x: 0, y: 0},
				fillRadialGradientEndRadius: radius,
				fillRadialGradientColorStops: [0, darkColor, 0.4, fullColor, 0.75, fullColor, 1, lightColor],
				fillPriority: 'radial-gradient',
				stroke: stroke,
				strokeWidth: 2,
				rotation: -90 - (angle / 2),
			}"
		/>
		<v-wedge
			:config="{
				x: 0,
				y: 0,
				radius: radius * 0.5,
				angle,
				fill: 'white',
				rotation: -90 - (angle / 2),
				opacity: 0.15,
			}"
		/>
		<v-wedge
			:config="{
				x: 0,
				y: 0,
				radius: radius * 0.35,
				angle,
				fill: 'white',
				rotation: -90 - (angle / 2),
				opacity: 0.1,
			}"
		/>
		<v-circle
			v-if="imgInfo.src"
			:config="{
				width: imgSize + 6,
				height: imgSize + 6,
				y: -(radius * 0.77),
				x: 0,
				fillLinearGradientStartPoint: {x: 0, y: 0},
				fillLinearGradientStartRadius: 0,
				fillLinearGradientEndPoint: {x: 0, y: imgSize + 6},
				fillLinearGradientColorStops: [0, lightColor, 1, darkColor],
				shadowColor: 'black',
				shadowBlur: 6,
				shadowOffset: { x: 0, y: 0 },
				shadowOpacity: 0.3
			}"
		/>
		<v-circle
			v-if="imgInfo.src"
			:config="{
				fillPatternImage: imgInfo.src,
				fillPatternScale: { x: imgInfo.scale, y: imgInfo.scale },
				fillPatternOffset: { x: imgInfo.offsetX, y: imgInfo.offsetY },
				width: imgSize,
				height: imgSize,
				y: -(radius * 0.77)
			}"
		/>
		<!-- <v-circle
			:config="{
				radius: 8,
				y: -radius / 3,
				x: 0,
				fillRadialGradientStartPoint: {x: 0, y: 0},
				fillRadialGradientStartRadius: 0,
				fillRadialGradientEndPoint: {x: 0, y: 0},
				fillRadialGradientEndRadius: 10,
				fillRadialGradientColorStops: [0, '#FFE69C', 0.5, '#FFDE7D'],
				fillPriority: 'radial-gradient',
				shadowColor: 'black',
				shadowBlur: 7,
				shadowOffset: { x: 0, y: 0 },
				shadowOpacity: 0.5,
				opacity: 0.5,
			}"
		/>
		<v-circle
			:config="{
				radius: 8,
				y: -(radius / 3) * 1.5,
				x: 0,
				fillRadialGradientStartPoint: {x: 0, y: 0},
				fillRadialGradientStartRadius: 0,
				fillRadialGradientEndPoint: {x: 0, y: 0},
				fillRadialGradientEndRadius: 10,
				fillRadialGradientColorStops: [0, '#FFE69C', 0.5, '#FFDE7D'],
				fillPriority: 'radial-gradient',
				shadowColor: 'black',
				shadowBlur: 7,
				shadowOffset: { x: 0, y: 0 },
				shadowOpacity: 0.5,
				opacity: 0.5,
			}"
		/> -->
		<!-- <v-line
			:config="{
				stroke: '#8B8B8B',
				strokeWidth: 2,
				points: [0, -radius + 22, 0, -radius + 12],
			}"
		/>
		<v-circle
			ref="wedgeBolt2"
			:config="{
				name: 'wedgeBolt2',
				radius: 5,
				y: -radius + 12,
				x: 0,
				fillRadialGradientStartPoint: {x: 0, y: 0},
				fillRadialGradientStartRadius: 0,
				fillRadialGradientEndPoint: {x: 0, y: 0},
				fillRadialGradientEndRadius: 10,
				fillRadialGradientColorStops: [0, '#8B8B8B', 1, '#626262'],
				fillPriority: 'radial-gradient',
			}"
		/>
		<v-line
			:config="{
				stroke: '#8B8B8B',
				strokeWidth: 2,
				points: [0, -10, 0, 0],
				x: -47,
				y: -radius + 25,
				rotation: -15,
			}"
		/>
		<v-circle
			ref="wedgeBolt1"
			:config="{
				name: 'wedgeBolt1',
				radius: 5,
				y: -radius + 15,
				x: -50,
				fillRadialGradientStartPoint: {x: 0, y: 0},
				fillRadialGradientStartRadius: 0,
				fillRadialGradientEndPoint: {x: 0, y: 0},
				fillRadialGradientEndRadius: 10,
				fillRadialGradientColorStops: [0, '#8B8B8B', 1, '#626262'],
				fillPriority: 'radial-gradient',
			}"
		/>
		<v-line
			:config="{
				stroke: '#8B8B8B',
				strokeWidth: 2,
				points: [0, -10, 0, 0],
				x: 47,
				y: -radius + 25,
				rotation: 15,
			}"
		/>
		<v-circle
			ref="wedgeBolt3"
			:config="{
				name: 'wedgeBolt3',
				radius: 5,
				y: -radius + 15,
				x: 50,
				fillRadialGradientStartPoint: {x: 0, y: 0},
				fillRadialGradientStartRadius: 0,
				fillRadialGradientEndPoint: {x: 0, y: 0},
				fillRadialGradientEndRadius: 10,
				fillRadialGradientColorStops: [0, '#8B8B8B', 1, '#626262'],
				fillPriority: 'radial-gradient',
			}"
		/> -->

		<v-group
			v-for="bolt in nrOfBolts"
			:key="bolt"
			:config="{ rotation: bolt * (angle / nrOfBolts) - ((angle / nrOfBolts) / 2) - (angle / 2) }"
		>
			<v-line
				:config="{
					stroke: '#8B8B8B',
					strokeWidth: 2,
					points: [0, -10, 0, 0],
					x: 0,
					y: -radius + 20,
				}"
			/>
			<v-circle
				:ref="el => bolts[bolt-1] = el"
				:config="{
					name: 'wedgeBolt',
					radius: 5,
					y: -radius + 12,
					x: 0,
					fillRadialGradientStartPoint: {x: 0, y: 0},
					fillRadialGradientStartRadius: 0,
					fillRadialGradientEndPoint: {x: 0, y: 0},
					fillRadialGradientEndRadius: 10,
					fillRadialGradientColorStops: [0, '#8B8B8B', 1, '#626262'],
					fillPriority: 'radial-gradient',
				}"
			/>
		</v-group>

		<v-line
			:config="{
				stroke,
				strokeWidth: 2,
				rotation: -angle / 2,
				points: [0, 0, 0, -radius],
				shadowColor: 'black',
				shadowBlur: 10,
				shadowOffset: { x: 3, y: 0 },
				shadowOpacity: 1
			}"
		/>
		<v-line
			:config="{
				stroke,
				strokeWidth: 2,
				rotation: angle / 2,
				points: [0, 0, 0, -radius],
				shadowColor: 'black',
				shadowBlur: 10,
				shadowOffset: { x: -3, y: 0 },
				shadowOpacity: 1
			}"
		/>
	</v-group>
</template>

<script>
import { colord } from "colord";
import { computed, ref, onBeforeUpdate, watchEffect } from 'vue'

export default {
	name: "Wedge",
	props: {
		img: {
			type: String,
			default: null,
		},
		color: {
			type: String,
			default: '#0dbe98',
		},
		rotation: {
			type: Number,
			default: undefined,
		},
		angle: {
			type: Number,
			default: undefined,
		},
		radius: {
			type: Number,
			default: undefined,
		},
	},
	setup(props) {
		const imgInfo = ref({ src: null })
		const imgSize = computed(() => Math.round(props.radius / 3.8))
		
		const loadImg = (img) => {
			const imageObj = new Image();
			imageObj.onload = function() {
				const {
					naturalWidth: w,
					naturalHeight: h,
				} = imageObj
				const scale = (w > h) ? imgSize.value / h : imgSize.value / w
				const scaledW = w * scale
				const scaledH = h * scale
				imgInfo.value = {
					src: imageObj,
					scale,
					offsetX: -(((scaledW - imgSize.value) / 2) + (imgSize.value / 2)) * (1/scale),
					offsetY: -(((scaledH - imgSize.value) / 2) + (imgSize.value / 2)) * (1/scale),
				}
			};
			imageObj.src = img
		}

		watchEffect(() => loadImg(props.img))

		const fullColor = computed(() => colord(props.color).toRgbString())
		const lightColor = computed(() => colord(props.color).lighten(0.2).toRgbString())
		const darkColor = computed(() => colord(props.color).darken(0.15).toRgbString())
		const stroke = computed(() => colord(props.color).darken(0.2).alpha(0.5).toRgbString())

		const bolts = ref([])
		onBeforeUpdate(() => {
            bolts.value = [];
        });
		const nrOfBolts = computed(() => Math.round(props.angle / 6.75) - 1)

		const getBolts = () => bolts.value
		
		return {
			imgInfo,
			imgSize,
			fullColor,
			lightColor,
			darkColor,
			stroke,
			nrOfBolts,
			bolts,
			getBolts,
		}
	},
};
</script>
